import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
//import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify);

export default new Vuetify({
    //theme: { disable: true }
    theme: {
        dark: {
            primary: '#f7e04b',
            // secondary: colors.pink,
            accent: '#f7e04b',//.v-application a など？
            // info: colors.lime,
            // success: colors.orange,
            // warning: colors.teal,
            //background: colors.black,
        },
        options: { customProperties: true },
    },
});
